import React, { Fragment } from "react"

import ModerationIcon from "./ModerationIcon"

const KnowledgeModerationButtons = ({
    canSave,
    isSaving,
    moderationStatus,
    suggestedModerationStatus,
    approve,
    reject,
    unmoderate
}) => (
    <Fragment>
        <div style={{ float: "left" }}>
            <ModerationIcon
                isButton={true}
                approvalSuggestion={suggestedModerationStatus}
            />
        </div>
        <div
            className="btn-group btn-moderate btn-moderate--with-text"
            style={{ marginRight: "5px" }}
        >
            <button
                className={
                    "btn btn-approve" +
                    (moderationStatus === true ? " active" : "")
                }
                disabled={isSaving || !canSave}
                onClick={moderationStatus === true ? unmoderate : approve}
            >
                <span className="btn-title visible-lg">
                    Approve{moderationStatus === true && "d"}
                </span>
                <i className="icon-hand-up" />
            </button>
            <button
                className={
                    "btn btn-reject" +
                    (moderationStatus === false ? " active" : "")
                }
                disabled={isSaving || !canSave}
                onClick={moderationStatus === false ? unmoderate : reject}
            >
                <span className="btn-title visible-lg">
                    Reject{moderationStatus === false && "ed"}
                </span>
                <i className="icon-hand-down" />
            </button>
        </div>
    </Fragment>
)
export default KnowledgeModerationButtons
